import styled from 'styled-components';
import { PendingIcon } from '@algoan/deep-dive/icons/pending-icon';

export enum StateIndicator {
  GREEN = 'GREEN',
  ORANGE = 'ORANGE',
  RED = 'RED',
  GREY = 'GREY',
  PENDING = 'PENDING',
  VOID = 'VOID',
}

interface CustomerStateIndicatorProps {
  state: StateIndicator;
  isAnonymousCustomer?: boolean;
  className?: string;
}

export const CustomerStateIndicator: React.FC<CustomerStateIndicatorProps> = ({
  state,
  isAnonymousCustomer,
  className,
}) => {
  if (state === StateIndicator.PENDING) {
    return <PendingIcon className={className} />;
  }

  return <S.State state={state} isAnonymousCustomer={isAnonymousCustomer} className={className} />;
};

const S = {
  State: styled.div<{ state: StateIndicator; isAnonymousCustomer?: boolean }>`
    background-color: ${(props) => {
      switch (props.state) {
        case StateIndicator.GREEN:
          return props.theme.scoreIndicatorColors.positiveValue;
        case StateIndicator.ORANGE:
          return props.theme.errorStateColors.orange;
        case StateIndicator.RED:
          return props.theme.legacy.red;
        case StateIndicator.VOID:
          return props.theme.white;
        default:
          return props.theme.scoreIndicatorColors.emptyValue;
      }
    }};
    border-radius: 50%;
    box-sizing: border-box;
    height: 8px;
    opacity: ${(props) => (props.isAnonymousCustomer ? '0.35' : '1')};
    width: 8px;
    ${({ state, theme }) =>
      state === StateIndicator.VOID ? `border: 1px solid ${theme.scoreIndicatorColors.emptyValue};` : ''};
  `,
};
